/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    Field,
    FieldFromJSON,
    FieldFromJSONTyped,
    FieldToJSON,
} from './Field';
import {
    Gender,
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
} from './Gender';
import {
    ProgramEventSeries,
    ProgramEventSeriesFromJSON,
    ProgramEventSeriesFromJSONTyped,
    ProgramEventSeriesToJSON,
} from './ProgramEventSeries';
import {
    SaleDateType,
    SaleDateTypeFromJSON,
    SaleDateTypeFromJSONTyped,
    SaleDateTypeToJSON,
} from './SaleDateType';
import {
    Subtotal,
    SubtotalFromJSON,
    SubtotalFromJSONTyped,
    SubtotalToJSON,
} from './Subtotal';
import {
    VenueCreateOrUpdateParams,
    VenueCreateOrUpdateParamsFromJSON,
    VenueCreateOrUpdateParamsFromJSONTyped,
    VenueCreateOrUpdateParamsToJSON,
} from './VenueCreateOrUpdateParams';

/**
 * 
 * @export
 * @interface ProgramEventUpdateParams
 */
export interface ProgramEventUpdateParams {
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    description?: string;
    /**
     * 
     * @type {Array<VenueCreateOrUpdateParams>}
     * @memberof ProgramEventUpdateParams
     */
    venues?: Array<VenueCreateOrUpdateParams>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventUpdateParams
     */
    online_event: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    online_event_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    url?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProgramEventUpdateParams
     */
    starts_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProgramEventUpdateParams
     */
    ends_at: Date;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    terms?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    picture_file_id?: string;
    /**
     * 
     * @type {Array<Field>}
     * @memberof ProgramEventUpdateParams
     */
    fields: Array<Field>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramEventUpdateParams
     */
    tags: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventUpdateParams
     */
    is_series?: boolean;
    /**
     * 
     * @type {Array<ProgramEventSeries>}
     * @memberof ProgramEventUpdateParams
     */
    series_dates?: Array<ProgramEventSeries>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventUpdateParams
     */
    show_remaining?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProgramEventUpdateParams
     */
    restrict_to_package_ids?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventUpdateParams
     */
    preregistration_enabled?: boolean;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof ProgramEventUpdateParams
     */
    currency: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    timezone: string;
    /**
     * 
     * @type {SaleDateType}
     * @memberof ProgramEventUpdateParams
     */
    sale_start_type?: SaleDateType;
    /**
     * 
     * @type {Date}
     * @memberof ProgramEventUpdateParams
     */
    sale_starts_at?: Date;
    /**
     * 
     * @type {SaleDateType}
     * @memberof ProgramEventUpdateParams
     */
    sale_end_type?: SaleDateType;
    /**
     * 
     * @type {Date}
     * @memberof ProgramEventUpdateParams
     */
    sale_ends_at?: Date;
    /**
     * 
     * @type {Subtotal}
     * @memberof ProgramEventUpdateParams
     */
    price?: Subtotal;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventUpdateParams
     */
    include_fee?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProgramEventUpdateParams
     */
    quantity_total?: number;
    /**
     * 
     * @type {Gender}
     * @memberof ProgramEventUpdateParams
     */
    gender?: Gender;
    /**
     * 
     * @type {number}
     * @memberof ProgramEventUpdateParams
     */
    minimum_age?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramEventUpdateParams
     */
    maximum_age?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventUpdateParams
     */
    has_external_registration: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProgramEventUpdateParams
     */
    external_registration_url?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramEventUpdateParams
     */
    feedback_enabled: boolean;
}

export function ProgramEventUpdateParamsFromJSON(json: any): ProgramEventUpdateParams {
    return ProgramEventUpdateParamsFromJSONTyped(json, false);
}

export function ProgramEventUpdateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramEventUpdateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'venues': !exists(json, 'venues') ? undefined : ((json['venues'] as Array<any>).map(VenueCreateOrUpdateParamsFromJSON)),
        'online_event': json['online_event'],
        'online_event_url': !exists(json, 'online_event_url') ? undefined : json['online_event_url'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'starts_at': (new Date(json['starts_at'])),
        'ends_at': (new Date(json['ends_at'])),
        'terms': !exists(json, 'terms') ? undefined : json['terms'],
        'picture_file_id': !exists(json, 'picture_file_id') ? undefined : json['picture_file_id'],
        'fields': ((json['fields'] as Array<any>).map(FieldFromJSON)),
        'tags': json['tags'],
        'is_series': !exists(json, 'is_series') ? undefined : json['is_series'],
        'series_dates': !exists(json, 'series_dates') ? undefined : ((json['series_dates'] as Array<any>).map(ProgramEventSeriesFromJSON)),
        'show_remaining': !exists(json, 'show_remaining') ? undefined : json['show_remaining'],
        'restrict_to_package_ids': !exists(json, 'restrict_to_package_ids') ? undefined : json['restrict_to_package_ids'],
        'preregistration_enabled': !exists(json, 'preregistration_enabled') ? undefined : json['preregistration_enabled'],
        'currency': CurrencyCodeFromJSON(json['currency']),
        'timezone': json['timezone'],
        'sale_start_type': !exists(json, 'sale_start_type') ? undefined : SaleDateTypeFromJSON(json['sale_start_type']),
        'sale_starts_at': !exists(json, 'sale_starts_at') ? undefined : (new Date(json['sale_starts_at'])),
        'sale_end_type': !exists(json, 'sale_end_type') ? undefined : SaleDateTypeFromJSON(json['sale_end_type']),
        'sale_ends_at': !exists(json, 'sale_ends_at') ? undefined : (new Date(json['sale_ends_at'])),
        'price': !exists(json, 'price') ? undefined : SubtotalFromJSON(json['price']),
        'include_fee': !exists(json, 'include_fee') ? undefined : json['include_fee'],
        'quantity_total': !exists(json, 'quantity_total') ? undefined : json['quantity_total'],
        'gender': !exists(json, 'gender') ? undefined : GenderFromJSON(json['gender']),
        'minimum_age': !exists(json, 'minimum_age') ? undefined : json['minimum_age'],
        'maximum_age': !exists(json, 'maximum_age') ? undefined : json['maximum_age'],
        'has_external_registration': json['has_external_registration'],
        'external_registration_url': !exists(json, 'external_registration_url') ? undefined : json['external_registration_url'],
        'feedback_enabled': json['feedback_enabled'],
    };
}

export function ProgramEventUpdateParamsToJSON(value?: ProgramEventUpdateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'summary': value.summary,
        'description': value.description,
        'venues': value.venues === undefined ? undefined : ((value.venues as Array<any>).map(VenueCreateOrUpdateParamsToJSON)),
        'online_event': value.online_event,
        'online_event_url': value.online_event_url,
        'url': value.url,
        'starts_at': (value.starts_at.toISOString()),
        'ends_at': (value.ends_at.toISOString()),
        'terms': value.terms,
        'picture_file_id': value.picture_file_id,
        'fields': ((value.fields as Array<any>).map(FieldToJSON)),
        'tags': value.tags,
        'is_series': value.is_series,
        'series_dates': value.series_dates === undefined ? undefined : ((value.series_dates as Array<any>).map(ProgramEventSeriesToJSON)),
        'show_remaining': value.show_remaining,
        'restrict_to_package_ids': value.restrict_to_package_ids,
        'preregistration_enabled': value.preregistration_enabled,
        'currency': CurrencyCodeToJSON(value.currency),
        'timezone': value.timezone,
        'sale_start_type': SaleDateTypeToJSON(value.sale_start_type),
        'sale_starts_at': value.sale_starts_at === undefined ? undefined : (value.sale_starts_at.toISOString()),
        'sale_end_type': SaleDateTypeToJSON(value.sale_end_type),
        'sale_ends_at': value.sale_ends_at === undefined ? undefined : (value.sale_ends_at.toISOString()),
        'price': SubtotalToJSON(value.price),
        'include_fee': value.include_fee,
        'quantity_total': value.quantity_total,
        'gender': GenderToJSON(value.gender),
        'minimum_age': value.minimum_age,
        'maximum_age': value.maximum_age,
        'has_external_registration': value.has_external_registration,
        'external_registration_url': value.external_registration_url,
        'feedback_enabled': value.feedback_enabled,
    };
}

